<template>
  <div class="row">
    <div class="col-12">
      <div class="media">
        <media-player :issue="issue" :share="false" :header="false"></media-player>
      </div>
    </div>
    <div class="col-12">
      <p>
      <h3><i>Interview with Dr. Somebody Somename & Somebody Othername</i></h3>
      </p>
      <p>
        Division of Molecular Carcinogenesis, The Netherlands Cancer Institute, Amsterdam, The Netherlands
      </p>
      <p>
        talking about their cover paper published in <i><a>Volume 7 Issue 25</a></i> of Oncotarget called <a><b>"Intrinsic resistance
        to PIM kinase inhibition in AML through p38α-mediated feedback activation of mTOR signaling"</b></a>
      </p>
    </div>
  </div>
</template>

<script>
  import MediaPlayer from '@/components/shared/MediaPlayerComponent'
  export default {
    name: 'interview-video',
    components: {
      MediaPlayer
    },
    props: ['issue']
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// InterviewVideoComponent.vue?1305c82d